import React from "react";
import { FieldRenderProps } from "react-final-form";
import { InputAdornment, TextField } from "@material-ui/core";

import withFieldControl from "components/FormControl/FieldControl";

import { Container, Wrapper } from "./styles";

type Props = { error?: string } & FieldRenderProps<any>;

class DurationFieldControl extends React.Component<Props> {
  get initialValue() {
    const {
      input: { value },
    } = this.props;

    return value;
  }

  get hours() {
    return this.initialValue.hours;
  }

  get minutes() {
    return this.initialValue.minutes;
  }

  onChange = ({
    hours,
    minutes,
  }: {
    hours: string | number;
    minutes: string | number;
  }) => {
    const { input } = this.props;
    const event: any = {
      target: { value: { hours, minutes } },
    };
    input.onChange(event);
  };

  onChangeHours = (event: any) => {
    const value = event.target.value.replace(/\D/g, "");
    const newHours = value ? Number.parseInt(value) : "";
    this.onChange({ hours: newHours, minutes: this.minutes });
  };

  onChangeMinutes = (event: any) => {
    const value = event.target.value.replace(/\D/g, "");
    const newMinutes = value ? Number.parseInt(value) : "";
    this.onChange({ hours: this.hours, minutes: newMinutes });
  };

  render() {
    const { error, meta } = this.props;

    return (
      <Container>
        <Wrapper>
          <TextField
            variant="outlined"
            margin="none"
            label="Duration"
            value={this.hours}
            InputProps={{
              endAdornment: <InputAdornment position="end">hr</InputAdornment>,
            }}
            helperText={((meta.touched || meta.dirty) && meta.error) || error}
            error={Boolean(
              ((meta.touched || meta.dirty) && meta.error) || error,
            )}
            onChange={this.onChangeHours}
            required
            fullWidth
          />
        </Wrapper>
        <Wrapper>
          <TextField
            variant="outlined"
            margin="none"
            label="Duration"
            value={this.minutes}
            InputProps={{
              endAdornment: <InputAdornment position="end">min</InputAdornment>,
            }}
            error={Boolean(
              ((meta.touched || meta.dirty) && meta.error) || error,
            )}
            onChange={this.onChangeMinutes}
            required
            fullWidth
          />
        </Wrapper>
      </Container>
    );
  }
}

export default withFieldControl(DurationFieldControl);
